import React from "react"
import {useTranslation} from "react-i18next"

import {LayoutBlock} from "../../components/Layout/LayoutBlock.tsx"
import {useDocumentTitle} from "../../utils/hooks.tsx"
import {DealsSection} from "./sections/DealsSection/DealsSection.tsx"
import {LeaderboardSection} from "./sections/LeaderboardSection/LeaderboardSection.tsx"
import {SettingsSection} from "./sections/SettingsSection/SettingsSection.tsx"
import {UpdateCenterSection} from "./sections/UpdateCenterSection/UpdateCenterSection.tsx"

export const SalesAssistant: React.FC = () => {
  const {t} = useTranslation()

  useDocumentTitle(t("SalesAssistant_DocumentTitle"))

  // TODO: add load SalesCycles for sales person
  // const {data, error, refetch} = useSaaSDashboardQuery()

  // if (error) {
  //   return (
  //     <LayoutBlock outerClassName={"py-16 bg-cr-blue-super-light grow"}>
  //       <GenericErrorAlert retry={refetch} />
  //     </LayoutBlock>
  //   )
  // }
  //
  // if (!data) {
  //   return <Loading size={"xl"} />
  // }

  return <SalesAssistantLoaded />
}

export const SalesAssistantLoaded: React.FC = () => {
  return (
    <LayoutBlock outerClassName={"py-16 bg-cr-blue-super-light grow"} innerClassName={"flex flex-col gap-12"}>
      <SettingsSection />
      <div className={"grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.5fr]"}>
        <div>
          <LeaderboardSection />
        </div>
        <div className={"relative"}>
          <UpdateCenterSection />
        </div>
      </div>
      <DealsSection />
    </LayoutBlock>
  )
}
